module.exports = __webpack_public_path__ + "static/media/loader.ac1b0cdd.gif";


/*****************
 ** WEBPACK FOOTER
 ** ../dist/components/loader.gif
 ** module id = 423
 ** module chunks = 0
 **/